import $ from 'jquery';

/**
 * Function TabCtrl
 */
function FaqCtrl() {
  this.$faq = $('.faq-block');
  this.$faqDT = this.$faq.find('dt');

  this.init();
}

FaqCtrl.prototype.init = function () {
  this.$faq.each(function () {
    const $self = $(this);
    if (!$self.hasClass('active')) {
      $self.removeClass('active').find('dd').hide();
    }
  })
  this.$faqDT.on('click', this.toggleBlock);
}

FaqCtrl.prototype.toggleBlock = function (e) {
  const $self = $(e.currentTarget);
  const $parent = $self.parent();
  const $next = $self.next('dd');
  if ($parent.hasClass('active')) {
    $next.stop().slideUp('fast');
    $parent.removeClass('active');
  } else {
    $next.stop().slideDown('fast');
    $parent.addClass('active');
  }
}


export default FaqCtrl;